import React from "react";

export const ShareResultCard = ({ result, hardestMatchup }) => (
  <div
    data-testid="share-result-card"
    className="relative rounded-[28px] overflow-hidden border border-white/20 p-6 sm:p-7"
    style={{
      background:
        "radial-gradient(circle at 15% 5%, rgba(255,16,122,0.45), transparent 55%), radial-gradient(circle at 95% 95%, rgba(0,229,255,0.3), transparent 55%), radial-gradient(circle at 50% 50%, rgba(168,85,247,0.15), transparent 65%), #0F0D16",
    }}
  >
    {/* Halftone corners */}
    <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full opacity-30 halftone" />
    <div className="absolute -bottom-8 -left-8 w-40 h-40 rounded-full opacity-25 halftone" style={{ filter: "hue-rotate(90deg)" }} />

    {/* Ticker stripe */}
    <div className="absolute top-0 inset-x-0 h-6 bg-black/60 border-b border-white/10 overflow-hidden">
      <div className="flex items-center h-full font-display tracking-[0.35em] text-[10px] text-[#FF107A] px-3">
        ★ PREDICT · CHOOSE · REVEAL · CELEBRITY SMASH ★
      </div>
    </div>

    <div className="relative pt-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md bg-[#FF107A] flex items-center justify-center glow-pink">
            <span className="font-display text-sm text-[#FDFBF7]">CS</span>
          </div>
          <span className="font-display text-sm tracking-[0.3em]">CELEBRITY SMASH</span>
        </div>
        <span className="text-[9px] tracking-[0.25em] uppercase text-[#FDFBF7]/60">daily result</span>
      </div>

      <div className="mt-6">
        <div className="text-[10px] tracking-[0.35em] uppercase text-[#00E5FF] font-bold">Archetype</div>
        <h3 className="font-display text-[3.4rem] sm:text-[4rem] leading-[0.85] tracking-tight text-[#FDFBF7] mt-1">
          {result.archetype.title.split(" ").map((w, i) => (
            <span key={i} className={i === 1 ? "text-[#FF107A]" : ""}>
              {w}
              {i < result.archetype.title.split(" ").length - 1 && " "}
            </span>
          ))}
        </h3>
        <p className="mt-2 text-xs tracking-[0.15em] uppercase text-[#FDFBF7]/70">{result.archetype.tagline}</p>
      </div>

      <div className="grid grid-cols-2 gap-3 mt-5">
        <Stat label="Prediction" value={`${result.predictionAccuracy}%`} accent="#FF107A" />
        <Stat label="Contrarian" value={`${result.contrarianScore}%`} accent="#A855F7" />
        <Stat label="Creative" value={`${result.creativePreference}%`} accent="#00E5FF" />
        <Stat label="Values" value={`${result.valuesPreference}%`} accent="#FFD700" />
      </div>

      <div className="mt-5 pt-4 border-t border-white/10 space-y-1 text-xs">
        <div className="flex justify-between text-[#FDFBF7]/60">
          <span className="tracking-[0.15em] uppercase">Top trait</span>
          <span className="text-[#FDFBF7] font-semibold normal-case">{result.topReasonLabel}</span>
        </div>
        {hardestMatchup && (
          <div className="flex justify-between text-[#FDFBF7]/60">
            <span className="tracking-[0.15em] uppercase">Hardest match</span>
            <span className="text-[#FDFBF7] font-semibold normal-case truncate ml-2">{hardestMatchup}</span>
          </div>
        )}
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-dashed border-white/15 pt-3">
        <span className="text-[9px] tracking-[0.3em] uppercase text-[#FDFBF7]/40 truncate max-w-[60%]">
          {typeof window !== "undefined" ? window.location.host : "celebritysmash.app"}
        </span>
        <span className="text-[9px] tracking-[0.3em] uppercase text-[#FDFBF7]/40">screenshot & share</span>
      </div>
    </div>
  </div>
);

const Stat = ({ label, value, accent }) => (
  <div className="rounded-xl bg-black/40 border border-white/10 px-3 py-2.5">
    <div className="text-[9px] tracking-[0.25em] uppercase text-[#FDFBF7]/60">{label}</div>
    <div className="font-display text-3xl mt-0.5 leading-none tabular" style={{ color: accent, textShadow: `0 0 10px ${accent}55` }}>
      {value}
    </div>
  </div>
);
